import { ImageGrid } from "../components/image-grid/ImageGrid";
import {
  VinoDataImage,
  generateStorefrontImage,
} from "../utils/generate-storefront-image";
interface ContentfulImageGridProps {
  __typename: string;
  images: Array<VinoDataImage>;
}

const test = ({ __typename }: ContentfulImageGridProps): boolean =>
  __typename === "VinoData_ImageGrid";

const create = (data: ContentfulImageGridProps): JSX.Element => {
  const transformedData = {
    ...data,
    images: data.images?.map((i) => generateStorefrontImage(i)) || [],
  };

  return <ImageGrid {...transformedData} />;
};

export default { test, create };
